module.exports = __webpack_public_path__ + "static/img/product-wrightinTwo.cb92bc59.png";